import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Perfil } from 'src/app/modules/admin/types/Perfil';

/** Código do órgão CGE — homolog/prod. */
const COD_ORGAO_CGE = '660';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  async autenticar(login: string, password: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(this.baseUrl + 'login', {
      login: login,
      password: password
    }, httpOptions).toPromise();
  }

  async reativarUsuario(login: string, password: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(this.baseUrl + 'reativar-usuario', {
      login: login,
      password: password
    }, httpOptions).toPromise();
  }

  reenviarSenha(login: string) {
    return this.http.post(this.baseUrl + `gerarNovaSenha`, { login: login }).toPromise();
  }

  verificarToken() {

  }

  getTokenUsuario() {
    return JSON.parse(localStorage.getItem('token'));
  }

  getTokenPerfil() {
    return JSON.parse(localStorage.getItem('tokenPerfil'));
  }

  getHeaderComTokenPerfil() {
    return {
      'Authorization': 'Bearer ' + this.getTokenPerfil(),
      'rejectUnauthorized': 'false'
    }
  }

  getHeaderComTokenUsuario() {
    return {
      'Authorization': 'Bearer ' + this.getTokenUsuario(),
      'rejectUnauthorized': 'false'
    }
  }

  getPerfil() {
    return JSON.parse(localStorage.getItem('perfil'));
  }

  getIdPerfil() {
    return JSON.parse(localStorage.getItem('perfil')).id_perfil;
  }

  getCodgPerfil() {
    return JSON.parse(localStorage.getItem('perfil')).codg_perfil;
  }

  getCodUnidadeAdministrativa() {
    return JSON.parse(localStorage.getItem('perfil')).cod_unidade_administrativa_sei;
  }

  /** Administrador vinculado à CGE: emissão completa (positiva, nada consta forçado, etc.). */
  isDeclaracaoEmissaoCompleta(): boolean {
    const perfil = this.getPerfil();
    if (!perfil) {
      return false;
    }
    const isAdmin = Number(perfil.codg_perfil) === Perfil.ADMINISTRADOR;
    const codOrgao = String(perfil.orgao ?? '').trim();
    return isAdmin && codOrgao === COD_ORGAO_CGE;
  }

  isDeclaracaoSomenteNegativa(): boolean {
    return !this.isDeclaracaoEmissaoCompleta();
  }

  clearLocalStorageLogOut() {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenPerfil');
    localStorage.removeItem('perfil');
    localStorage.removeItem('user');
  }

  canActivate() {
    if (localStorage.getItem('token') != null && localStorage.getItem('user') != null) {
      return true;
    } else {
      return false;
    }
  }
}
